var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"svgicon",style:({fontSize:_vm.size+'px'}),attrs:{"aria-hidden":"true"},on:{"click":_vm.trigger}},[_c('use',{attrs:{"xlink:href":_vm.iconName}})])}
var staticRenderFns = []

export { render, staticRenderFns }